import { EventEmitter, QueryList } from '@angular/core';
import { InfluencerGroups } from '../../../../models/influencer-group';
import { GroupService } from '../../../services/group-details/group.service';
import { UserService } from '../../../services/user.service';
import { NumberUtils } from '../../../utils/number.utils';
import { ValidationHandlerService } from '../../../core/validation-handler.service';
import { AchooUserAvatarComponent } from '../../../core/achoo-user-avatar/achoo-user-avatar.component';
import { PlaceholderVisibilityService } from '../../../services/placeholder-visibility/placeholder-visibility.service';
import { CommonConstant, RecentlyVisitedInfluencerGroup } from '../../../app.constants';
import { Router } from '@angular/router';
import { ActionDetails, ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { CacheService } from '../../../services/cache/cache.service';
import { AppSettings } from '../../../utils/app-settings';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { NewGroupSettingsComponent } from '../../group-details/new-group-settings/new-group-settings.component';
var GroupActionType;
(function (GroupActionType) {
    GroupActionType["DELETE"] = "delete";
    GroupActionType["VIEW"] = "view";
})(GroupActionType || (GroupActionType = {}));
var GroupItemComponent = /** @class */ (function () {
    function GroupItemComponent(groupService, router, validationHandlerService, placeholderVisibilityService, cacheService, userService, eventTracker, modalService) {
        this.groupService = groupService;
        this.router = router;
        this.validationHandlerService = validationHandlerService;
        this.placeholderVisibilityService = placeholderVisibilityService;
        this.cacheService = cacheService;
        this.userService = userService;
        this.eventTracker = eventTracker;
        this.modalService = modalService;
        this.showGroupSetting = false;
        this.isRequestReview = false;
        this.influencerGroupList = [];
        this.eventAddInfluencerGroup = new EventEmitter();
        this.eventDeleteInfluencerGroup = new EventEmitter();
        this.listProjectOfAdvertiser = [];
        this.editGroupEvent = new EventEmitter();
        this.editOrCreateProjectEvent = new EventEmitter();
        this.isUpdatingGroupInfo = false;
    }
    GroupItemComponent.prototype.ngOnInit = function () {
        this.isRecentlyVisitedInfluencerGroup = this.influencerGroup.name === RecentlyVisitedInfluencerGroup.name ? true : false;
        this.isRequestReview = AppSettings.isRequestReview();
        if (!this.isRecentlyVisitedInfluencerGroup) {
            this.loadInfluencerGroup(this.influencerGroup.id);
        }
    };
    GroupItemComponent.prototype.normalizeNumberData = function (value) {
        return NumberUtils.normalizeNumberToString(value);
    };
    GroupItemComponent.prototype.executeAddInfluencerGroup = function () {
        this.eventAddInfluencerGroup.emit(this.influencerGroup);
    };
    GroupItemComponent.prototype.executeDeleteInfluencerGroup = function () {
        this.eventDeleteInfluencerGroup.emit(this.influencerGroup);
    };
    GroupItemComponent.prototype.executeEditInfluencerGroup = function () {
        var _this = this;
        if (this.showGroupSetting) {
            this.showGroupSetting = false;
            setTimeout(function () {
                _this.reloadGroupData(_this.influencerGroup.id);
            }, 100);
        }
        else {
            this.showGroupSetting = true;
        }
    };
    GroupItemComponent.prototype.reloadGroupData = function (groupId) {
        this.influencerGroupData = null;
        this.loadInfluencerGroup(groupId);
    };
    GroupItemComponent.prototype.openGroupDetails = function (activeAccount) {
        this.cacheService.disableCacheRemoving();
        if (this.isRecentlyVisitedInfluencerGroup) {
            return this.router.navigate(['groups', 'monthly-visit'], {
                queryParams: { activeAccount: activeAccount }
            });
        }
        return this.router.navigate(["/groups/" + this.influencerGroup.id], {
            queryParams: { activeAccount: activeAccount }
        });
    };
    Object.defineProperty(GroupItemComponent.prototype, "numberRemaingInfluencer", {
        get: function () {
            if (!this.influencerGroup) {
                return 0;
            }
            var numOfRemaining = this.influencerGroup.totalInfluencers - this.influencerGroup.influencers.length;
            // we're limiting the max number of influencer in group is 1000
            return numOfRemaining >= CommonConstant.MAX_INFLUENCERS_INTO_GROUP ? CommonConstant.MAX_INFLUENCERS_INTO_GROUP + 1 : numOfRemaining;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupItemComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    GroupItemComponent.prototype.invalidActionData = function (actionType) {
        var params;
        if (actionType === GroupItemComponent.UPDATE_CONFIG || actionType === GroupItemComponent.ADD_INFLUENCER) {
            params = {
                action: UserActionType.UPDATE,
                source: ActionSource.PAGE,
                actionDetails: actionType === GroupItemComponent.UPDATE_CONFIG ? ActionDetails.UPDATE_CONFIG : ActionDetails.ADDED_INFLUENCERS,
            };
        }
        else {
            params = {
                action: actionType === GroupActionType.DELETE ? UserActionType.DELETE
                    : actionType === GroupActionType.VIEW ? UserActionType.VIEW : UserActionType.UPDATE,
                source: ActionSource.PAGE
            };
        }
        return {
            action: UserActionType.ACTION,
            item: Page.GROUP,
            target: {
                type: TargetType.INFLUENCER_GROUP
            },
            params: params,
            activePage: {
                type: ActivePages.GROUP_OVERVIEW,
            }
        };
    };
    Object.defineProperty(GroupItemComponent.prototype, "showLoader", {
        get: function () {
            if (this.influencerGroup.name === RecentlyVisitedInfluencerGroup.name && this.isLoadingRecentlyVisitedInfluencerList) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupItemComponent.prototype, "showTotalPendingInfluencer", {
        get: function () {
            return this.influencerGroup.totalPendingInfluencers > 0 && !this.isRecentlyVisitedInfluencerGroup && this.isRequestReview;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupItemComponent.prototype, "openNewGroupSetting", {
        get: function () {
            return this.influencerGroupData;
        },
        enumerable: true,
        configurable: true
    });
    GroupItemComponent.prototype.loadInfluencerGroup = function (influencerGroupId) {
        var _this = this;
        this.cacheService.get("InfluencerGroupDetail" + influencerGroupId, this.groupService.getInfluencerGroup(influencerGroupId)).subscribe(function (res) {
            _this.influencerGroupData = res ? res : null;
        });
    };
    GroupItemComponent.prototype.updateGroupEvent = function (evt) {
        this.editGroupEvent.emit(evt);
    };
    GroupItemComponent.prototype.updateNewValueForCachedData = function (groupId, newData) {
        if (this.cacheService.has("influencer_group_data_" + groupId)) {
            this.cacheService.set("influencer_group_data_" + groupId, newData);
        }
    };
    GroupItemComponent.prototype.editOrCreateProject = function (project) {
        this.editOrCreateProjectEvent.emit(project);
    };
    GroupItemComponent.prototype.beforeSubmitGroupSetting = function () {
        this.showGroupSetting = false;
    };
    GroupItemComponent.prototype.afterSubmitGroupSetting = function (evt) {
        if (evt.isError) {
            this.showGroupSetting = true;
            this.modalService.open(this.saveGroupSettingError, null, true);
        }
    };
    GroupItemComponent.UPDATE_CONFIG = 'update config';
    GroupItemComponent.ADD_INFLUENCER = 'add influencer';
    return GroupItemComponent;
}());
export { GroupItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer-groups/group-item/group-item.component.ts.pre-build-optimizer.js